import { formatStatus } from "./TextFormatter";

const WALLET_CARD_TYPES = ["google_pay", "apple_pay"];
export const ALL_CARD_TYPES = ["card"].concat(WALLET_CARD_TYPES);

export function isCardType(cardType) {
  return ALL_CARD_TYPES.includes(cardType);
}

export function isWalletCardType(cardType) {
  return WALLET_CARD_TYPES.includes(cardType);
}

export function isBankDebitType(cardType) {
  return ["sepa_debit"].includes(cardType);
}

export function getCardDescription(cardType, cardBrand) {
  if (isWalletCardType(cardType)) {
    return `${cardBrandLabel(cardBrand)} (${walletCardLabel(cardType)})`;
  } else if (isBankDebitType(cardType)) {
    return formatStatus(cardType);
  } else {
    return cardBrandLabel(cardBrand);
  }
}

export function walletCardLabel(cardType) {
  switch(cardType) {
    case "google_pay":
    case "apple_pay":
      return formatStatus(cardType);
    default:
      return cardType;
  }
}

export function cardBrandLabel(brand) {
  switch(brand) {
    case "visa":
      return "Visa";
    case "mastercard":
      return "Mastercard";
    case "amex":
      return "American Express";
    case "discover":
      return "Discover";
    case "jcb":
      return "JCB";
    case "diners":
      return "Diners Club";
    case "unionpay":
      return "UnionPay";
    case "maestro":
      return "Maestro";
    case "elo":
      return "Elo";
    case "hipercard":
      return "Hipercard";
    case "aura":
      return "Aura";
    case "google_pay":
      return "Google Pay";
    case "apple_pay":
      return "Apple Pay";
    default:
      return brand;
  }
}

export function formatPaymentMethod(value) {
  switch(value) {
    case "credit_card": 
      return "Payment Method"; // Can be bank debit
    case "payment_terms":
      return "Payment Terms";
    default:
      return value;
  }
}

export function formatExpirationDate(month, year) {
  if (month == "1" && year == "1970") {
    return "No Expiration";
  } else if (month && year) {
    return `${month} / ${year}`;
  } else {
    return "";
  }
}